import React, { Component } from "react";
import {
  FormGroup,
  ControlLabel,
  ToggleButton,
  ToggleButtonGroup,
  ButtonToolbar
} from "react-bootstrap";
import "./styles.css";

class SelectForm extends Component {
  render() {
    return (
      <FormGroup controlId={ this.props.id }>
        <ControlLabel>{ this.props.label }</ControlLabel>
        <ButtonToolbar>
          <ToggleButtonGroup
            type="radio"
            name="options"
            defaultValue={ this.props.value }
            onChange={ this.props.onChange }
          >
            {this.props.items.map((value, index) => (
              <ToggleButton key={index} value={value}>
                {value}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </ButtonToolbar>
      </FormGroup>
    )
  }
}

export default SelectForm;



// WEBPACK FOOTER //
// ./src/components/SelectForm/index.js